import React from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import WorkItemIcon from '@atlaskit/icon/core/work-item';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	successRoot: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: token('space.150'),
		width: '100%',
		boxSizing: 'border-box',
	},
	titleSection: {
		display: 'flex',
		alignItems: 'center',
		alignSelf: 'stretch',
		boxSizing: 'border-box',
		height: '64px',
		gap: token('space.150'),
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		borderRadius: token('radius.large'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		backgroundColor: token('color.background.input'),
	},
	headerWorkItemIconWrap: {
		backgroundColor: token('elevation.surface'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		paddingTop: token('space.050'),
		paddingRight: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.050'),
	},
	headingWrapper: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		minWidth: '0px',
	},
	successSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		alignSelf: 'stretch',
		backgroundColor: token('elevation.surface.raised'),
	},
	successPillLayout: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: token('space.150'),
		width: '100%',
		boxSizing: 'border-box',
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
	},
	successPill: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.075'),
		borderRadius: token('radius.full'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		backgroundColor: token('elevation.surface'),
		paddingTop: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
	},
});

export type UpdateQueueGroupCardSuccessProps = {
	heading: string;
	successMessage: string;
};

export const UpdateQueueGroupCardSuccess = ({
	heading,
	successMessage,
}: UpdateQueueGroupCardSuccessProps): React.JSX.Element => {
	return (
		<Box xcss={styles.successRoot} testId="update-queue-group-card-success">
			<Flex xcss={styles.titleSection}>
				<Flex xcss={styles.headerWorkItemIconWrap} alignItems="center" justifyContent="center">
					<WorkItemIcon label="" spacing="none" color={token('color.icon.accent.blue')} />
				</Flex>
				<Box xcss={styles.headingWrapper}>
					<Heading size="small">{heading}</Heading>
				</Box>
			</Flex>
			<Box xcss={styles.successSection} testId="update-queue-group-card.success-pill-wrap">
				<Box xcss={styles.successPillLayout} testId="update-queue-group-card.success-inner">
					<Flex xcss={styles.successPill} testId="update-queue-group-card.success-pill">
						<CheckMarkIcon label="" color={token('color.icon.success')} spacing="none" />
						<Text size="small">{successMessage}</Text>
					</Flex>
				</Box>
			</Box>
		</Box>
	);
};
